import { Helmet } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';

import CalendarPage from './pages/CalendarPage';
import CartPage from './pages/CartPage';
import ConfirmPage from './pages/ConfirmPage';
import HomePage from './pages/HomePage';
import ItemDetailPage from './pages/ItemDetailPage';
import OrderDetailPage from './pages/OrderDetailPage';

export default function App() {
  return (
    <>
      <Helmet>
        <title>공세계 - 카페 주문 예약</title>
        <meta name="description" content="카페 공세계의 베이커리 및 음료 주문 예약 서비스" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <link
          rel="stylesheet"
          as="style"
          crossOrigin="anonymous"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.css"
        />
      </Helmet>

      <div className="antialiased">
        <Routes>
          <Route path="/" element={<CalendarPage />} />
          <Route path="/menu" element={<HomePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/confirm" element={<ConfirmPage />} />
          <Route path="/order/:token" element={<OrderDetailPage />} />
          <Route path="/item/:id" element={<ItemDetailPage />} />
        </Routes>
      </div>
    </>
  );
}
